module.exports = __webpack_public_path__ + "img/myxy.1641520899224.png";